var zo = zo || {};




// Home fold slider 
//-----------------------------------------------------------------
zo.foldSlider = function() {

    var $slider = $('.js_foldSlider').removeClass('loading');

    if (!$slider.length) {
        return;
    }

    $slider.slick({
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 1000,
        arrows: true,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        focusOnSelect: false,
        accessibility: false,
        infinite: true,
        centerMode: true,
        centerPadding: 0,
        touchThreshold: 12,
        slide: '.fold__item',
        appendDots: $('.fold__dots_home'),
        touchThreshold: 12,
        prevArrow: '<a class="fold__arrows_item arrow-prev"><i class="icon-arrow-small-left"></i></a>',
        nextArrow: '<a class="fold__arrows_item arrow-next"><i class="icon-arrow-small-right"></i></a>',
        cssEase: 'cubic-bezier(.84,.2,.6,1.04)'
    });

};


zo.foldPartners = function() {

    var $slider = $('.foldPartners').removeClass('loading');

    if (!$slider.length) {
        return;
    }

    $slider.slick({
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: true,
        dots: false,
        slidesToShow: 5,
        slidesToScroll: 1,
        focusOnSelect: false,
        accessibility: false,
        infinite: true,
        centerMode: true,
        centerPadding: 0,
        touchThreshold: 12,
        slide: '.fold__item',
        // appendDots: $('.fold__dots'),
        prevArrow: '<a class="fold__arrows_item arrow-prev"><i class="icon-arrow-small-left"></i></a>',
        nextArrow: '<a class="fold__arrows_item arrow-next"><i class="icon-arrow-small-right"></i></a>',
        cssEase: 'cubic-bezier(.84,.2,.6,1.04)',
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3
                 
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2    
                }
            },          
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1
                }
            }           
        ]
    });
};


// Sliders
//-----------------------------------------------------------------


// zo.foldSlider = function() {

//     var $slider = $('.js_foldSlider').removeClass('loading');

//     if (!$slider.length) {
//         return;
//     }

//     $slider.slick({
//         autoplay: true,
//         fade: true,
//         speed: 1000,
//         infinite: true,
//         dots: true,
//         arrows: true,
//         adaptiveHeight: false,
//         slide: '.fold__item',
//         appendDots: $('.fold__dots'),
//         appendArrows: $('.fold__arrows'),
//         touchThreshold: 12,
//         prevArrow: '<a class="fold__arrows_item arrow-prev"><i class="icon-arrow-small-left"></i></a>',
//         nextArrow: '<a class="fold__arrows_item arrow-next"><i class="icon-arrow-small-right"></i></a>',
//         cssEase: 'cubic-bezier(.84,.2,.6,1.04)'
//     });

// };


// upcoming Slier
zo.ordinationSlider = function() {

    var $slider = $('.js_ordinationSlider').removeClass('loading');

    if (!$slider.length) {
        return;
    }

    $slider.slick({
        autoplay: false,
        autoplaySpeed: 5000,
        arrows: false,
        dots: true,
        slidesToShow: 4,
        focusOnSelect: false,
        accessibility: false,
        adaptiveHeight: true,
        centerMode: false,
        centerPadding: 0,
        touchThreshold: 12,
        slide: '.ordination__item',
        appendDots: $('.ordination__dots'),
         responsive: [

            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1
                
              }
            },
             
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2
                
              }
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3
                
              }
            }
          
        ]
       
    });

};


zo.recentSlider = function() {

    var $slider = $('.js_recentSlider').removeClass('loading');

    if (!$slider.length) {
        return;
    }

    $slider.slick({


        autoplay: false,
        autoplaySpeed: 5000,
        arrows: false,
        dots: true,
        slidesToShow: 3,
        focusOnSelect: false,
        accessibility: false,
        adaptiveHeight: true,
        centerMode: false,
        centerPadding: 0,
        touchThreshold: 12,
        slide: '.ordination__item',
        appendDots: $('.recentnews__dots'),
        responsive: [
             
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2
                }
            },

            
        ]
       
    });

};



$(document).ready(function (){
    zo.foldSlider();
    zo.foldPartners();
    zo.ordinationSlider();
    zo.recentSlider();
});

